import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table } from "antd";
import Wrapper from "../../components/wrapper";
import { API } from "../../utilities/constants";

const MonthYearDropdown = ({
  selectedMonth,
  selectedYear,
  onMonthChange,
  onYearChange,
}) => {
  const months = Array.from({ length: 12 }, (_, index) =>
    (index + 1).toString().padStart(2, "0")
  );
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, index) =>
    (currentYear - index).toString()
  );

  return (
    <div
      style={{
        textAlign: "center",
        position: "fixed",
        top: "90px",
        transform: "translateX(191%)",
        zIndex: 1000,
      }}
    >
      <label htmlFor="month">
        {" "}
        <strong>Select Month:</strong>{" "}
      </label>
      <select
        id="month"
        style={{ marginRight: "11px" }}
        value={selectedMonth}
        onChange={(e) => onMonthChange(e.target.value)}
      >
        {months.map((month) => (
          <option key={month} value={month}>
            {month}
          </option>
        ))}
      </select>

      <label htmlFor="year">
        {" "}
        <strong> Select Year:</strong>{" "}
      </label>
      <select
        id="year"
        value={selectedYear}
        onChange={(e) => onYearChange(e.target.value)}
      >
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );
};

const UserStatistics = () => {
  const [post, setPost] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("01");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataTime = { month: selectedMonth, year: selectedYear };
        const token = sessionStorage.getItem("token");
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.post(API.user_logs, dataTime, config);

        setPost(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [selectedMonth, selectedYear]);

  const nonNullData = (activity_page) => {
    return Object.keys(activity_page).reduce((acc, key) => {
      if (activity_page[key] !== 0 && activity_page[key] !== null) {
        acc[key] = activity_page[key];
      }
      return acc;
    }, {});
  };

  const nonNullData2 = (activity_export) => {
    return Object.keys(activity_export).reduce((acc, key) => {
      if (activity_export[key] !== 0 && activity_export[key] !== null) {
        acc[key] = activity_export[key];
      }
      return acc;
    }, {});
  };

  const columns = [
    {
      title: <strong>Email</strong>,
      dataIndex: "email",
      width: 130,
    },
    {
      title: <strong>User Name</strong>,
      dataIndex: "username",
      width: 130,
    },
    {
      title: <strong>Data Page Login</strong>,
      dataIndex: "activity_page",
      key: "activity_page",
      render: (text, record) => (
        <div>
          {Object.entries(nonNullData(record.activity_page)).map(([key, value]) => (
            <p key={key}>
              {key}: {value}
            </p>
          ))}
        </div>
      ),
      width: 130,
    },
    {
      title: <strong>Data Export Login</strong>,
      dataIndex: "activity_export",
      key: "activity_export",
      render: (text, record) => (
        <div>
          {Object.entries(nonNullData2(record.activity_export)).map(([key, value]) => (
            <p key={key}>
              {key}: {value}
            </p>
          ))}
        </div>
      ),
      width: 130,
    },
  ];

  const handleMonthChange = (selectedMonth) => {
    setSelectedMonth(selectedMonth);
  };

  const handleYearChange = (selectedYear) => {
    setSelectedYear(selectedYear);
  };

  return (
    <>
      <Wrapper heading={"14"} innerHeading={"10"}>
        <div>
          <div>
            <div style={{ padding: "23px" }}>
              <MonthYearDropdown
                selectedMonth={selectedMonth}
                selectedYear={selectedYear}
                onMonthChange={handleMonthChange}
                onYearChange={handleYearChange}
              />
            </div>
            <div></div>
            <Table
              columns={columns}
              dataSource={post}
              pagination={{
                pageSize: 50,
              }}
              scroll={{
                y: 430,
              }}
            />
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default UserStatistics;
